import React, { useMemo, useState, useEffect } from 'react'
import { Button, Table, TableBody, TableRow, TableCell, TextField, CardContent, Pagination, Box, SelectField, Option } from "@deere/fuel-react";
import { DataGridPro,GridActionsCellItem } from '@mui/x-data-grid-pro';
import { useField } from '../../hooks/useField.js';
import { saveSubtierMasterData, deleteSubtierRegistry, linkSubtierMaster, createSubtierSupplierRelation } from '../../services/survey.service.js'
import { useOktaAuth } from '@okta/okta-react'
import PositionedSnackbarAlert from '../../components/PositionedSnackbarAlert.js'
import { getCountry } from "../../services/external.service";
import MoreIcon from '@mui/icons-material/MoreVertOutlined';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import LinkIcon from '@mui/icons-material/LinkOutlined';
import {SUBTIER_MENU_ACTIONS,GRAL_NAVIGATION,SUBTIER_ADMIN_TITLE,GRAL_VALIDATION_MSGS,GRAL_ALERT_SEVERITIES} from "../../utils/constants";
import {GenericFuelModal} from '../../components/modals/GenericFuelModal';
import {GoldenRecordModal} from '../../components/modals/GoldenRecordModal';
import {SUBTIER_SOURCE_SYSTEM} from '../../utils/constants.js';
import {useUserInfo} from '../../providers/userProvider.js';
import {saveSubtierRecords} from '../../services/survey.service.js';


export const LikeNameContent = ({ rows, setRefreshMasterData }) => {
    const [columns, setColumns] = useState([])
    const [likeNameMap, setLikeNameMap] = useState(undefined)
    const { authState } = useOktaAuth();

    const itemsPerPage = 5;
    const [page, setPage] = useState(1);
    const [noOfPages, setNoOfPages] = useState(0);
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [countryList, setCountryList] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const [selectedEntryKey, setSelectedEntryKey] = useState(null)
    const [contextMenu, setContextMenu] = React.useState(null);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [subtier, setSubtier] = React.useState(null);
    const [showGoldenRecordModal, setShowGoldenRecordModal] = useState(false);

    const baseFields = {
        subtierSupplierName: '',
        streetAddress: '',
        country: { value: '', children: '' },
        city: '',
        state: '',
        postalCode: '',
        states: [],
        subtiersIds: []
    }
    const fields = useField(new Map(), baseFields)
    const userInfo = useUserInfo();
    const createdBy = userInfo? userInfo.userID : '';

    const openContextMenu = (e,id) => {
        setSelectedRows([Number(id)]);
        for ( const subTierGroupID of rows.keys() ) {
           const tmpSubTierGroup = rows.get(subTierGroupID)
           const subTier = tmpSubTierGroup.find(st => {
                return st.id === id
           })
           if ( subTier !== undefined ) {
                setSelectedEntryKey(subTierGroupID);
                break;
           }
        }
        setContextMenu(
          contextMenu === null
            ? { mouseX: e.clientX - 2, mouseY: e.clientY - 4 }
            : null
        );
    };

    const openGoldenRecordModal = (id) =>{
        setShowGoldenRecordModal(true);
        for ( const subTierGroupID of rows.keys() ) {
            const tmpSubTierGroup = rows.get(subTierGroupID)
            const tmpSubTier = tmpSubTierGroup.find(st => {
                 return st.id === id
            })
            if ( tmpSubTier !== undefined ) {
                setSubtier(tmpSubTier)
                break;
            }
         }
    }

    useEffect(() => {
        if (rows instanceof Map) {
            setLikeNameMap(rows)
            setNoOfPages(Math.ceil(rows.size / itemsPerPage))
        }
    }, [rows])

    useEffect(() => {
        if (countryList.length === 0) {
            getCountry(authState.accessToken.accessToken).then(response => {
                if (Array.isArray(response)) {
                    response.sort((a, b) => {
                        let fa = a.name.toLowerCase(),
                            fb = b.name.toLowerCase();
                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    })
                    setCountryList(response)
                }
            }).catch(error => {
                console.log(error);
                setCountryList([])
            });
        };
    }, []);

    const handleChange = (event, value) => {
        event.preventDefault()
        setPage(value);
    };

    const deleteSelectedRows = (subtierIdList, entryKey) => {
            deleteSubtierRegistry(subtierIdList, authState.accessToken.accessToken).then((response) => {
            deleteFromMap(subtierIdList, entryKey);
        }).catch(err => {
            console.log(err)
            setSeverity(GRAL_ALERT_SEVERITIES.error)
            setOpenAlert(true);
            setMessage(GRAL_VALIDATION_MSGS.error_while_deleting)
            setTimeout(() => {
              setOpenAlert(false);
            }, 4000)      
        });
    };

    const handleUpdate = (e, mapKey) => {
        e.preventDefault();
        let payload = undefined
        let entryFormFields = undefined;
        let stateList = undefined;
        let countryCode = undefined;

        if (!fields instanceof Map) {
            console.error('useField hook is not working correctly on like name content');
        }
        else {
            entryFormFields = fields.value.get(mapKey);
            if (!entryFormFields) {
                console.error(`mapEntryKeyValue to find an specifict object value : ${mapKey}`)
                console.error('useField hook was not finding the value to create the payload to save a new golden record.');
            }
        }
        console.log(entryFormFields);
        stateList = entryFormFields && Array.isArray(entryFormFields.states) ? entryFormFields.states : [];
        countryCode = entryFormFields && entryFormFields.country && entryFormFields.country.value ? entryFormFields.country.value : '';
        const selectedIDs = entryFormFields && Array.isArray(entryFormFields.subtiersIds) ? entryFormFields.subtiersIds.map(({ subtierId }) => subtierId) : [];
        const selectedSuppliers = entryFormFields && Array.isArray(entryFormFields.subtiersIds) ? entryFormFields.subtiersIds.map(({ supplierNo }) => supplierNo) : [];
        const tierLevel = entryFormFields && Array.isArray(entryFormFields.subtiersIds) && entryFormFields.subtiersIds.length > 0 ? entryFormFields.subtiersIds[0].tierLevel : ""
        const productType = entryFormFields && Array.isArray(entryFormFields.subtiersIds) && entryFormFields.subtiersIds.length > 0 ? entryFormFields.subtiersIds[0].productType : ""
        const isDiverseEnterprise = entryFormFields && Array.isArray(entryFormFields.subtiersIds) && entryFormFields.subtiersIds.length > 0 ? entryFormFields.subtiersIds[0].isDiverseEnterprise : ""

        payload = [{
            ids: selectedIDs,
            supplierName: entryFormFields && entryFormFields.subtierSupplierName ? entryFormFields.subtierSupplierName : '',
            streetAddress: entryFormFields && entryFormFields.streetAddress ? entryFormFields.streetAddress : '',
            country: entryFormFields && entryFormFields.country.children ? entryFormFields.country.children : '',
            city: entryFormFields && entryFormFields.city ? entryFormFields.city : '',
            state: entryFormFields && entryFormFields.state.value ? entryFormFields.state.value : '',
            postalCode: entryFormFields && entryFormFields.postalCode ? entryFormFields.postalCode : '',
            tierLevel: tierLevel,
            productType: productType,
            isDiverseEnterprise: isDiverseEnterprise
        }]

        const goldenRecordExtraFields={
            "supplierNumbers": selectedSuppliers,
            "createdBy": createdBy,
            "sourceSystem": SUBTIER_SOURCE_SYSTEM
         }
        const goldenRecord = [{...payload[0], ...goldenRecordExtraFields}]
        console.log(goldenRecord);
        if (!validatePayload(payload, stateList, countryCode)) {
            saveSubtierRecords(authState.accessToken.accessToken,goldenRecord).then(res => {
                saveSubtierMasterData(authState.accessToken.accessToken, payload).then(response => {
                    setOpenAlert(false);
                    setMessage('');
                    if (response) {
                        setRefreshMasterData(true);
                        setSeverity('success')
                        deleteFromMap(selectedIDs, mapKey);
                        setOpenAlert(true);
                        setMessage(`Update was success, Golden Records Created : ${response.masterRecordsCreated}  with Subtier Relations Created : ${response.masterSubtierRelationsCreated}`)
                        setTimeout(() => {
                            setOpenAlert(false);
                        }, 4000)
                        fields.reset(mapKey)
                    }
                }).catch(error => {
                    setSeverity('error')
                    setOpenAlert(false)
                    console.log(error);
                    setOpenAlert(true);
                    setMessage('An error ocurred during update process')
                    setTimeout(() => {
                        setOpenAlert(false);
                    }, 4000)
                });
            }).catch(error => {
                setSeverity('error')
                setOpenAlert(false)
                console.log(error);
                setOpenAlert(true);
                setMessage('An error ocurred during update process')
                setTimeout(() => {
                    setOpenAlert(false);
                }, 4000)
            });
            
        }
    }

    function validatePayload(payloadArray, stateList, countryCode) {
        setSeverity('error')
        setOpenAlert(false)
        let payload = undefined
        if (Array.isArray(payloadArray) && payloadArray.length > 0) {
            payload = payloadArray[0]
        }
        const isCountryWithStates = typeof countryCode === 'string' && countryCode.trim().length > 0 && Array.isArray(stateList) && stateList.length > 0;

        if ((Array.isArray(payload.ids) && payload.ids.length === 0)) {
            setOpenAlert(true);
            setMessage('Select at least one Subtier option to create a golden record')
            setTimeout(() => {
                setOpenAlert(false);
            }, 4000)
            return true
        }
        if (typeof payload.supplierName === 'string' && payload.supplierName.trim().length === 0) {
            setOpenAlert(true);
            setMessage('Supplier Name is required')
            setTimeout(() => {
                setOpenAlert(false);
            }, 4000)
            return true
        }
        if (typeof payload.streetAddress === 'string' && payload.streetAddress.trim().length === 0) {
            setOpenAlert(true);
            setMessage('Street Address is required')
            setTimeout(() => {
                setOpenAlert(false);
            }, 4000)
            return true
        }
        if (typeof payload.country === 'string' && payload.country.trim().length === 0) {
            setOpenAlert(true);
            setMessage('Country is required')
            setTimeout(() => {
                setOpenAlert(false);
            }, 4000)
            return true
        }
        if (isCountryWithStates) {
            if (typeof payload.state === 'string' && payload.state.trim().length === 0) {
                setOpenAlert(true);
                setMessage('State is required')
                setTimeout(() => {
                    setOpenAlert(false);
                }, 4000)
                return true
            }
        }
        if (typeof payload.city === 'string' && payload.city.trim().length === 0) {
            setOpenAlert(true);
            setMessage('City is required')
            setTimeout(() => {
                setOpenAlert(false);
            }, 4000)
            return true
        }
        if (typeof payload.postalCode === 'string' && payload.postalCode.trim().length === 0) {
            setOpenAlert(true);
            setMessage('Postal Code is required')
            setTimeout(() => {
                setOpenAlert(false);
            }, 4000)
            return true
        }

        return false;
    }

    function deleteFromMap(deletedIds, mapKey) {
        if (Array.isArray(deletedIds) && deletedIds.length > 0 && mapKey) {
            const auxLikeNameMap = likeNameMap instanceof Map ? likeNameMap : new Map();
            const dataArrayInTable = auxLikeNameMap.get(mapKey);
            if (Array.isArray(dataArrayInTable) && dataArrayInTable.length > 0) {
                const auxLikeNameDataArray = [...dataArrayInTable]
                const filteredArray = Array.isArray(auxLikeNameDataArray)
                    ? auxLikeNameDataArray.filter(({ subtierId }) => !deletedIds.includes(subtierId))
                    : []
                if (filteredArray.length === 0) {
                    auxLikeNameMap.delete(mapKey)
                    setLikeNameMap(new Map(auxLikeNameMap))
                } else {
                    auxLikeNameMap.set(mapKey, [...filteredArray]);
                    setLikeNameMap(new Map(auxLikeNameMap))
                }
            }
        }
    }

    const handleSelection = (rowSelectionModel, auxRows, key) => {
        const selectedIDs = new Set(rowSelectionModel);
        const selectedRowDataInGrid = auxRows.filter((row) => selectedIDs.has(row.id));
        fields.onChange(selectedRowDataInGrid, key, 'subtiersIds', undefined)
    }


    const handleCountrySelection = (event, key, actionMeta) => {
        fields.onChange(event, key, 'country', actionMeta)
        fields.callBackStates(authState.accessToken.accessToken, key)
    }

    const handleStateSelection = (event, key, actionMeta) => {
        fields.onChange(event, key, 'state', actionMeta)
    }

    const handleSubmitLink = async(subtierMasterLink) =>{
        try{      
            
            createSubtierSupplierRelation(subtierMasterLink,authState.accessToken.accessToken).then(response => {
                if(response.status===200){
                    const payload = {
                        "subtierId":subtierMasterLink.rawSubtierId,
                        "surveySubtierId":response.data.surveySubtierId
                    }
                    linkSubtierMaster(payload,authState.accessToken.accessToken).then( response => {
                        deleteFromMap([subtier.id], selectedEntryKey);
                        setSeverity(GRAL_ALERT_SEVERITIES.success)
                        setOpenAlert(true);
                        setRefreshMasterData(true);
                        setMessage(GRAL_VALIDATION_MSGS.succesfully)
                        setTimeout(() => {
                          setOpenAlert(false);
                        }, 4000)
                    }).catch(err => {
                        setSeverity(GRAL_ALERT_SEVERITIES.error)
                        setOpenAlert(true);
                        setMessage(GRAL_VALIDATION_MSGS.survey_link)
                        setTimeout(() => {
                            setOpenAlert(false);
                        }, 4000)
                    })
                }else{
                    setSeverity(GRAL_ALERT_SEVERITIES.error)
                    setOpenAlert(true);
                    setMessage(GRAL_VALIDATION_MSGS.subtier_link)
                    setTimeout(() => {
                        setOpenAlert(false);
                    }, 4000)
                }
            })
        }catch(e){
            setSeverity(GRAL_ALERT_SEVERITIES.error)
            setOpenAlert(true);
            setMessage(GRAL_VALIDATION_MSGS.error_while_saving)
            setTimeout(() => {
                setOpenAlert(false);
            }, 4000)
        }
    } 

    const selectCountryField = (entryKey) => {
        const mapEntry = fields.value instanceof Map && fields.value.has(entryKey) ? fields.value.get(entryKey) : null;
        const countryCode = mapEntry && mapEntry.country && mapEntry.country.value ? mapEntry.country.value : '';

        return (<SelectField
            defaultValue=''
            label="Country"
            name='country'
            onChange={(event, actionMeta) => { handleCountrySelection(event, entryKey, actionMeta) }}
            value={countryCode}
        >
            <Option
                disabled
                hidden
                value=''
            >
                Select
            </Option>
            {
                Array.isArray(countryList) && countryList.length > 0 ?
                    countryList.map((country, index) => <Option key={index} value={country.iso2CountryCode}>
                        {country.name}
                    </Option>)
                    : []
            }
        </SelectField>)
    }

    const selectStateField = (entryKey) => {

        const mapEntry = fields && fields.value instanceof Map && fields.value.has(entryKey) ? fields.value.get(entryKey) : null
        const stateList = mapEntry && Array.isArray(mapEntry.states) ? mapEntry.states : [];

        return (<SelectField
            defaultValue=""
            label="State"
            name='state'
            onChange={(event, actionMeta) => { handleStateSelection(event, entryKey, actionMeta) }}
        >
            <Option
                disabled
                hidden
                value=''
            >
                Select
            </Option>

            {
                Array.isArray(stateList) && stateList.length > 0 ? stateList.map((state, index) => (
                    <Option key={index} value={state.name} name='state'>
                        {state.name}
                    </Option>
                )) : <Option key={1} value={''} name='state'>
                    {'No states were found'}
                </Option>
            }

        </SelectField >)
    }


    useMemo(() => {
        setColumns([
            {
                field: 'supplierNo',
                headerName: 'Supplier No.',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'supplierName',
                headerName: 'Supplier Name',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
                width: 400
            },
            {
                field: 'subtierSupplierName',
                headerName: 'Subtier Supplier Name',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
                width: 300
            },
            {
                field: 'streetAddress',
                headerName: 'Street Address',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
                width: 370
            },
            {
                field: 'country',
                headerName: 'Country',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'city',
                headerName: 'City',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'state',
                headerName: 'State',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'postalCode',
                headerName: 'Postal Code',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'tierLevel',
                headerName: 'Tier Level',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'productType',
                headerName: 'Product Type',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'isDiverseEnterprise',
                headerName: 'Is this entity considered a diverse enterprise?',
                editable: false,
                cellClassName: 'supplier-tier-cell-theme',
            },
            {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                width: 70,
                cellClassName: 'actions',
                getActions: ({ id }) => {
                  return [
                    <GridActionsCellItem
                      icon={<MoreIcon />}
                      label="More"
                      color="inherit"
                      onClick={(e)=>openContextMenu(e,id)}
                    />
                  ];
                },
              },
        ])
    }, [])

    const styleBoxSX = {
        width: '100%',
        '& .supplier-tier-cell-theme': {
            align: 'center',
            fontSize: 'small',
            padding: 0,
            margin: 0,
        }
    }

    const paginationSx = {
        margin: 5,
    }

    const customTextField = (entryKey, name, label) => {
        return (
            <TextField name={`${name}`} value={fields.value instanceof Map && fields.value.has(entryKey) ? fields.value.get(entryKey)[name] : null}
                onChange={event => { fields.onChange(event, entryKey, null, null) }} size="small" label={`${label}`} />
        )
    }


    const renderSubTable = (entryRows, entryKey) => {
        const auxRows = Array.isArray(entryRows) ? entryRows : []

        return (
            <div key={entryKey} id={entryKey}>
                <Box sx={{ ...styleBoxSX }}>
                    {
                        auxRows.length > 0 ?
                            <DataGridPro editMode="row" rows={auxRows} columns={columns} checkboxSelection disableRowSelectionOnClick hideFooter autoHeight
                                onRowSelectionModelChange={(rowSelectionModel) => handleSelection(rowSelectionModel, auxRows, entryKey)} 
                                componentsProps={{
                                    row: {
                                      onContextMenu: (e)=>handleContextMenu(e, entryKey),
                                      style: { cursor: "context-menu" }
                                    }
                                }}
                            />
                            : null
                    }
                </Box>
                <Table size='small'>
                    <TableBody>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell size='small' sx={{ bgcolor: "lightgrey" }}><b>Golden Record Entry</b></TableCell>
                            <TableCell size='small' colSpan={2} sx={{ bgcolor: "lightgrey" }}>
                                {
                                    customTextField(entryKey, 'subtierSupplierName', 'Subtier Supplier Name')
                                }
                            </TableCell>
                            <TableCell sx={{ bgcolor: "lightgrey" }} colSpan={2}>
                                {
                                    customTextField(entryKey, 'streetAddress', 'Street Address')
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell size='small' sx={{ bgcolor: "lightgrey" }}>
                                {selectCountryField(entryKey)}
                            </TableCell>
                            <TableCell size='small' sx={{ bgcolor: "lightgrey" }}>
                                {
                                    customTextField(entryKey, 'city', 'City')
                                }
                            </TableCell>
                            <TableCell size='small' sx={{ bgcolor: "lightgrey" }}>{
                                selectStateField(entryKey)
                            }</TableCell>
                            <TableCell size='small' sx={{ bgcolor: "lightgrey" }}>
                                {
                                    customTextField(entryKey, 'postalCode', 'Postal Code')
                                }
                            </TableCell>
                            <TableCell size='small' sx={{ bgcolor: "lightgrey" }}><Button onClick={(event) => handleUpdate(event, entryKey)} variant="primary" sx={{ alignSelf: "flex-end", position: "relative", bottom: -10, right: -15 }}>Update</Button></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        )
    }

    const handleContextMenuClose = () => {
        setContextMenu(null);
    };

    const handleContextMenu = (event, entryKey) => {
        event.preventDefault();
        setSelectedRows([Number(event.currentTarget.getAttribute("data-id"))]);
        setSelectedEntryKey(entryKey);
        setContextMenu(
            contextMenu === null
            ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
            : null
        );
    };

    const showDeleteValidation = (show) => {
        setShowValidationModal(show);
    };

    return (
        <>
            <PositionedSnackbarAlert message={message} open={openAlert} severity={severity} />
            <CardContent sx={{ maxHeight: 600, overflowY: "scroll", width: '100%' }}>
                {
                    (likeNameMap instanceof Map && likeNameMap.size > 0) ?
                        Array.from(likeNameMap.entries()).slice((page - 1) * itemsPerPage, page * itemsPerPage).map((entry) => {
                            const entryRows = entry && entry.length >= 2 ? entry[1] : [];
                            const entryKey = entry && entry.length >= 2 ? entry[0] : undefined;
                            return renderSubTable(entryRows, entryKey)
                        })
                        : null
                }
            </CardContent>
            <Menu
                open={contextMenu !== null}
                onClose={handleContextMenuClose}
                anchorReference="anchorPosition"
                anchorPosition={
                contextMenu !== null
                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                    : undefined
                }
                componentsProps={{
                root: {
                    onContextMenu: (e) => {
                    e.preventDefault();
                    handleContextMenuClose();
                    }
                }
                }}
            >
                <MenuItem onClick={()=>{handleContextMenuClose();showDeleteValidation(true)}}><DeleteIcon/> {SUBTIER_MENU_ACTIONS.DELETE}</MenuItem>
                <MenuItem onClick={()=>{handleContextMenuClose();openGoldenRecordModal(selectedRows[0])}}><LinkIcon /> {SUBTIER_MENU_ACTIONS.LINK}</MenuItem>
            </Menu>
            {showGoldenRecordModal && <GoldenRecordModal showModal={showGoldenRecordModal}  setShowModal={setShowGoldenRecordModal} titleModal={'Link to a Golden Record'} labelBtnPrimary={'Save'} labelBtnSecondary={'Cancel'} submitFn={handleSubmitLink} subtier={subtier} />}
            <GenericFuelModal title={SUBTIER_ADMIN_TITLE} 
                              show={showValidationModal}
                              message={GRAL_VALIDATION_MSGS.delete_validation} 
                              secondaryBtn={SUBTIER_MENU_ACTIONS.CANCEL} 
                              primaryButton={SUBTIER_MENU_ACTIONS.DELETE}
                              handleSave={()=>{ deleteSelectedRows(selectedRows, selectedEntryKey) /* deleteFunction(selectedRows,isUnique) */; setShowValidationModal(false);}}
                              handleClose={()=>setShowValidationModal(false)}
            />
            <tfoot>
                <Pagination sx={{ ...paginationSx }} count={noOfPages} size='large' page={page} onChange={handleChange} />
            </tfoot>
        </>
    )
} 